import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

// eslint-disable-next-line no-unused-vars
const styles = (theme) => ({});

class FormErrorMessage extends React.Component {
  render() {
    const { message, ...itemProps } = this.props;

    return (
      <Typography paragraph color={"error"} {...itemProps}>
        {message}
      </Typography>
    );
  }
}

FormErrorMessage.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
};

export default withStyles(styles)(FormErrorMessage);
